import React from 'react'
import TaskTypeTaskIcon from '../../../../../assets/icon/TaskTypeTaskIcon'
import TaskTypeBugIcon from '../../../../../assets/icon/TaskTypeBugIcon'
import TaskTypeMeetingIcon from '../../../../../assets/icon/TaskTypeMeetingIcon'
import TaskTypeDocumentIcon from '../../../../../assets/icon/TaskTypeDocumentIcon'
import TaskTypeApprovalIcon from '../../../../../assets/icon/TaskTypeApprovalIcon'

export interface TaskTypeOption {
    id: string
    label: string
    icon: React.ReactNode
}

export const TASK_TYPES: TaskTypeOption[] = [
    { id: 'task', label: 'Задача', icon: <TaskTypeTaskIcon /> },
    { id: 'bug', label: 'Ошибка', icon: <TaskTypeBugIcon /> },
    { id: 'meeting', label: 'Встреча', icon: <TaskTypeMeetingIcon /> },
    { id: 'document', label: 'Документ', icon: <TaskTypeDocumentIcon /> },
    { id: 'approval_review', label: 'Согласование/проверка', icon: <TaskTypeApprovalIcon /> },
]

export const getTaskType = (id?: string | null): TaskTypeOption => {
    return TASK_TYPES.find((t) => t.id === id) || TASK_TYPES[0]
}
